import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from 'react';

import appConsts from "../utils/constants/appConsts";


const StripeProvider = ({ children }) => {
    const [stripe, setStripe] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function initializeStripe() {
            const stripeInstance = await loadStripe(appConsts.stripePublicKey);
            setStripe(stripeInstance);
            setIsLoading(false);
        }

        initializeStripe();
    }, []);

    return (
        <Elements stripe={stripe}>
            {!isLoading && children}
        </Elements>
    );
};

export  default StripeProvider;
